"use client";
import { jsx } from "react/jsx-runtime";
import { LanguageContext } from "./LanguageContext.js";
const LanguageProvider = ({ language, setLanguage, children }) => (
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  /* @__PURE__ */ jsx(LanguageContext.Provider, { value: { language, setLanguage }, children })
);
export {
  LanguageProvider
};
